






































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import shrinkableMenu from "../components/shrinkable-menu/shrinkable-menu.vue";
import tagsPageOpened from "../components/tags-page-opened.vue";
import breadcrumbNav from "../components/breadcrumb-nav.vue";
import fullScreen from "../components/fullscreen.vue";
import lockScreen from "../components/lockscreen/lockscreen.vue";
import notice from "../components/notices/notice.vue";
import util from "../lib/util";
import copyfooter from "../components/Footer.vue";
import LanguageList from "../components/language-list.vue";
import AbpBase from "../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import userpwd from "../components/setuserpwd.vue";
@Component({
  components: {
    shrinkableMenu,
    tagsPageOpened,
    breadcrumbNav,
    fullScreen,
    lockScreen,
    notice,
    copyfooter,
    LanguageList,
    userpwd,
  },
})
export default class Main extends AbpBase {
  shrink: boolean = false;
  get userName() {
    return this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
  }
  isFullScreen: boolean = false;
  messageCount: string = "0";
  isbindtoken = false;
  tokenshow = false;
  tokenimg = "";
  isshowpwd = false;
  googlekey = "";
  googlecode = "";
  key = ''
  systemsetting = new proxy.SystemSettingDto();
  get openedSubmenuArr() {
    return this.$store.state.app.openedSubmenuArr;
  }
  get menuList() {
    return this.$store.state.app.menuList;
  }
  get pageTagsList() {
    return this.$store.state.app.pageOpenedList as Array<any>;
  }
  get currentPath() {
    return this.$store.state.app.currentPath;
  }
  get lang() {
    return this.$store.state.app.lang;
  }
  get avatorPath() {
    return localStorage.avatorImgPath;
  }
  get cachePage() {
    return this.$store.state.app.cachePage;
  }
  get menuTheme() {
    return this.$store.state.app.menuTheme;
  }
  get mesCount() {
    return this.$store.state.app.messageCount;
  }
  GenerateSettlement() {
    new proxy.MerchantDayClearServiceProxy().generateSettlement().then((x) => {
      this.$Notice.success({ title: "生成成功" });

    });
  }
  CloseOrderchange(e) {
    let str = "";
    if (e) {
      str = "您确定要关闭系统进单吗?关闭后商户订单无法推送进系统";
    } else {
      str = "您确定要开启系统进单吗?开启后商户可正常推单";
    }
    this.$Modal.confirm({
      title: str,
      onOk: () => {
        this.systemsetting.isCloseOrder = e;
        new proxy.SystemSettingServiceProxy()
          .save(this.systemsetting)
          .then((x) => {
            this.$Notice.success({ title: "操作成功" });
          });
      },
    });
  }
  okbind() {
    new proxy.GoogleTokenServiceProxy()
      .bindToken(this.googlekey, this.googlecode)
      .then((x) => {
        this.$Notice.success({ title: "绑定成功" });
        this.tokenshow = false;
        this.isbindtoken = true;
      });
  }
  init() {

    let pathArr = util.setCurrentPath(this, this.$route.name as string);
    this.$store.commit("app/updateMenulist");
    if (pathArr.length >= 2) {
      this.$store.commit("app/addOpenSubmenu", pathArr[1].name);
    }
    let messageCount = 3;
    this.messageCount = messageCount.toString();
    this.checkTag(this.$route.name);
    
    new proxy.SystemSettingServiceProxy().queryModel().then((x) => {
      this.systemsetting = x;
      new proxy.GoogleTokenServiceProxy().isBind().then((x) => {
      this.isbindtoken = x;
      if(this.systemsetting.isEnableGoogleCheckLogin){
        if(!this.isbindtoken){
          this.handleClickUserDropdown("bindtoken");
        }
      }
    });
    });
  }
  toggleClick() {
    this.shrink = !this.shrink;
  }
  handleClickUserDropdown(name: string) {
    if (name === "ownSpace") {
      this.isshowpwd = true;
    } else if (name === "loginout") {
      this.$store.commit("app/logout", this);
      util.abp.auth.clearToken();
      location.reload();
    } else if (name == "bindtoken") {
      this.googlecode = "";
      new proxy.GoogleTokenServiceProxy().createToken().then((x) => {
        let json = JSON.parse(x);
        this.googlekey = json.googleKey;
        this.tokenimg = json.qrcode;
        this.key = json.key;
        this.tokenshow = true;
      });
    } else if (name == "cleartoken") {
      this.$Modal.confirm({
        render: (h) => {
          return h("Input", {
            props: {
              value: this.googlecode,
              autofocus: true,
              placeholder: "请输入谷歌令牌验证码",
            },
            on: {
              input: (val) => {
                this.googlecode = val;
              },
            },
          });
        },
        onOk: () => {
          new proxy.GoogleTokenServiceProxy()
            .clearToken(this.googlecode)
            .then((x) => {
              this.$Notice.success({ title: "解绑成功" });
              location.reload();
            });
        },
      });
    }
  }
  checkTag(name?: string) {
    let openpageHasTag = this.pageTagsList.some((item: any) => {
      if (item.name === name) {
        return true;
      } else {
        return false;
      }
    });
    if (!openpageHasTag) {
      util.openNewPage(
        this,
        name as string,
        this.$route.params || {},
        this.$route.query || {}
      );
    }
  }
  handleSubmenuChange(val: string) {
    // console.log(val)
  }
  beforePush(name: string) {
    if (name === "accesstest_index") {
      return false;
    } else {
      return true;
    }
  }
  fullscreenChange(isFullScreen: boolean) {
    // console.log(isFullScreen);
  }
  @Watch("$route")
  routeChange(to: any) {
    this.$store.commit("app/setCurrentPageName", to.name);
    let pathArr = util.setCurrentPath(this, to.name);
    if (pathArr.length > 2) {
      this.$store.commit("app/addOpenSubmenu", pathArr[1].name);
    }
    this.checkTag(to.name);
    localStorage.currentPageName = to.name;
  }
  @Watch("lang")
  langChange() {
    util.setCurrentPath(this, this.$route.name as string);
  }
  mounted() {
    this.init();
  }
  created() {
    this.$store.commit("app/setOpenedList");
  }
}
